module.exports = __webpack_public_path__ + "static/media/teapotgardens.ced8ae56.md";